import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/header.component';
import { map, Observable, switchMap, tap } from 'rxjs';
import { MarksheetDto, PostDto, StudentDto } from '@oracychampions/api-interfaces';
import { ActivatedRoute } from '@angular/router';
import { NoItemsComponent } from '../../shared/no-items.component';
import { StudentsService } from '../students.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MarksheetComponent } from '../feed/marksheet.component';

@Component({
  selector: 'oc-student',
  standalone: true,
  imports: [CommonModule, HeaderComponent, NoItemsComponent],
  providers: [],
  template: ` <div class="container-fluid page">
    <oc-header [headerTitle]="(student$ | async)?.name || ''" [backLink]="['/group', groupId, 'students']"> </oc-header>

    <div class="student-marksheets">
      <div class="student-marksheets-header">Marksheets</div>
      <div class="student-marksheets-body">
        <oc-no-items
          *ngIf="(marksheets$ | async)?.length === 0"
          mainTitle="No Marksheets"
          subTitle="There are no marksheets for this student"
        ></oc-no-items>
        <table *ngIf="(marksheets$ | async)?.length ?? 0 > 0" class="table">
          <thead>
            <tr>
              <th class="pinch">Date</th>
              <th>Post</th>
              <th class="pinch">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let marksheet of marksheets$ | async">
              <td class="pinch">{{ marksheet.createDate | date }}</td>
              <td>{{ $any(marksheet).post.title }}</td>
              <td class="pinch">
                <a href="javascript:void(0)" (click)="openMarksheet($any(marksheet).post)">Marksheet</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="student-marksheets-footer"></div>
    </div>
  </div>`,
  styles: `
    .student-marksheets {
      background: white;
      border-radius: 0.65rem;

      .student-marksheets-header {
        padding: 0.65rem 1rem;
        font-size: 1.3rem;
        font-weight: 500;
        border-bottom: 1px solid #eee;
      }

      .student-marksheets-body {
        
      }

      .student-marksheets-footer {
        min-height: 1px;
      }

      .pinch {
        width: 0;
        white-space: nowrap;
      }
    }
  `,
})
export class StudentComponent {
  private route = inject(ActivatedRoute);
  private studentsService = inject(StudentsService);
  private modalService = inject(NgbModal);

  public student$: Observable<StudentDto>;
  public marksheets$: Observable<MarksheetDto[]>;

  public student: StudentDto;
  public groupId: string | null;

  constructor() {
    this.groupId = this.route.parent?.snapshot.params['id'];
    this.student$ = this.route.data.pipe(
      map((data) => data['student']),
      tap((student) => (this.student = student)),
    );
    this.marksheets$ = this.student$.pipe(
      switchMap((student) => this.studentsService.getStudentMarksheets(student.id)),
    );
  }

  openMarksheet(post: PostDto) {
    const modalRef = this.modalService.open(MarksheetComponent, { fullscreen: true });
    modalRef.componentInstance.readonly = true;
    modalRef.componentInstance.studentTabs = false;
    modalRef.componentInstance.post = { ...post, students: [this.student] };
  }
}
